import { Events } from '@/services/Events';
import { CONTEXTUAL_MENU_OFFSET } from '@/constants/ui';
import type { TEvent } from '@/obsidianApi/TEvent';
import type { BasicTransformEvent, FabricObject, IText, Point } from 'fabric';

function onMoveContextualMenu(options: BasicTransformEvent & { target: FabricObject }) {
    const { mb } = (options.target as FabricObject).oCoords; // middle bottom position
    emitContextualMenuPositionUpdate(mb.clone());
}

function onSelectContextualMenu(
    options: Partial<TEvent> & {
        selected: FabricObject[];
    },
) {
    const { mb } = options.selected[0].oCoords;
    emitContextualMenuPositionUpdate(mb.clone());
}

function onTextChangeContextualMenu(options: { target: IText }) {
    const { mb } = options.target.oCoords;
    emitContextualMenuPositionUpdate(mb.clone());
}

function onMouseWheelContextualMenu() {
    Events.emit('contextual-menu-wheel');
}

function emitContextualMenuPositionUpdate(vector2: Point) {
    Events.emit('contextual-menu-position', { x: vector2.x, y: vector2.y + CONTEXTUAL_MENU_OFFSET });
}

export { onMouseWheelContextualMenu, onMoveContextualMenu, onSelectContextualMenu, onTextChangeContextualMenu };
